import { Video } from '@tribal-worldwide-london/fa-analytics';
import {
  EventCommonProps,
  performVWBasicVideoPlayerMilestoneReached,
  performVWBasicVideoPlayerPauseClick,
  performVWBasicVideoPlayerPlayClick,
} from '../events';

export const handleVideoPlay = (
  commonFields: EventCommonProps,
  fields: Video
) => {
  performVWBasicVideoPlayerPlayClick({
    ...commonFields,
    videoFields: {
      ...fields,
    },
  });
};

export const handleVideoPause = (
  commonFields: EventCommonProps,
  fields: Video
) => {
  performVWBasicVideoPlayerPauseClick({
    ...commonFields,
    videoFields: {
      ...fields,
    },
  });
};

export const handleVideoEnded = (
  commonFields: EventCommonProps,
  fields: Video
) => {
  performVWBasicVideoPlayerMilestoneReached({
    ...commonFields,
    videoFields: {
      ...fields,
      milestone: 100,
    },
  });
};

export const handleVideoMilestone = (
  commonFields: EventCommonProps,
  fields: Video
) => {
  performVWBasicVideoPlayerMilestoneReached({
    ...commonFields,
    videoFields: {
      ...fields,
    },
  });
};
